import { InputLabel } from "@visma-netvisor/react-component-library";
import styled from "styled-components";

export const StyledInputLabel = styled(InputLabel)`
  cursor: pointer;
  height: 100%;
`;
